import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Text, ActionLink, GridContainer } from '@custom-components';
import { PulseWrapper } from '../List.styles';
import { approvalConfigShape } from '../helperFunctions';
import { Secure } from '../../../../containers/admin/Secure/Secure';
import { permission } from '../../../../containers/admin/Secure/permission';

const permissions = [permission.view.approvalsConfiguration, permission.edit.approvalsConfiguration];
class ApprovalConfigTable extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(approvalConfigShape).isRequired,
    messages: PropTypes.shape({}),
    setModal: PropTypes.func.isRequired,
    setOpenConfig: PropTypes.func.isRequired
  };

  static defaultProps = {
    messages: {
      createdOnLabel: 'Created On',
      updatedOnLabel: 'Updated On',
      createdByLabel: 'Created By'
    }
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  resolveMessages = () => {
    const { messages } = this.props;
    return { ...ApprovalConfigTable.defaultProps.messages, ...messages };
  };

  renderRows = () => {
    const { data, setModal, setOpenConfig } = this.props;
    if (!data || !data.length) return [];
    return data.map((configData) => {
      const { id, configuredBy, updatedAt, createdAt } = configData;
      return {
        id,
        createdOn: <Text.CopyParagraph>{createdAt}</Text.CopyParagraph>,
        updatedOn: <Text.CopyParagraph>{updatedAt}</Text.CopyParagraph>,
        createdBy: <Text.CopyParagraph>{configuredBy.emailAddress}</Text.CopyParagraph>,
        actionLink: (
          <Secure reqPermission={permissions}>
            <ActionLink
              onClick={() => {
                setModal('viewDetails');
                setOpenConfig(configData);
              }}
            >
              <Text.HeadingSixth noMargins>View Details</Text.HeadingSixth>
            </ActionLink>
            <ActionLink
              onClick={() => {
                setModal('deleteConfig');
                setOpenConfig(configData);
              }}
            >
              <Text.HeadingSixth noMargins>Delete</Text.HeadingSixth>
            </ActionLink>
          </Secure>
        )
      };
    });
  };

  render() {
    const { createdOnLabel, updatedOnLabel, createdByLabel } = this.resolveMessages();
    return (
      <GridContainer style={{ width: '100%' }}>
        <PulseWrapper>
          <Table
            minTableWidth="100%"
            headerCellsConfig={{ roles: { width: '200px' } }}
            rows={[
              { id: 'createdOn', label: createdOnLabel },
              { id: 'updatedOn', label: updatedOnLabel },
              { id: 'createdBy', label: createdByLabel },
              { id: 'actionLink', label: '' }
            ]}
          >
            {this.renderRows()}
          </Table>
        </PulseWrapper>
      </GridContainer>
    );
  }
}

export default ApprovalConfigTable;
